<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"><nav>
    <img alt="logo" class="image-form" src="../../assets/logo.png">
    <ul>
        <li style="font-size: x-large;"><em class="fa fa-user"></em> User Login</li>
   
    </ul>
</nav>
